<template>
  <div class="btn" @click="onClick">
    <img :src="image" alt/>
  </div>
</template>

<script>
import backBlack from '../../assets/images/ic_arrow_left.png'
import backWhite from '../../assets/svg/back_white.svg'
import { verdictEmpty } from '@/utils/tools'

export default {
  name: 'LeftButton',
  props: {
    clickNative: {
      type: Function,
      default: () => {
      }
    },
    backStatus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      image: backBlack
    }
  },
  mounted() {
    this.image = this.backStatus === 0 ? backBlack : backWhite
  },
  methods: {
    onClick() {
      if (!verdictEmpty(this.clickNative)) {
        this.clickNative()
        return
      }
      this.$JD.goBack()
    }
  },
  watch: {
    backStatus: {
      immediate: true,
      handler: function (status) {
        this.image = status === 0 ? backBlack : backWhite
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 0.4rem;
  height: 0.4rem;

  img {
    width: 0.4rem;
    height: 0.4rem;
  }
}
</style>
